<template>
    <div class="page-about">
        <div class="row">
            <div class="title">About Me</div>
            <div class="desc">
                Hello — I’m Hanbyeol Jang, a Senior Product Designer who enjoys bringing clarity and structure to complex products.<br/><br/> Most of my work has been on data-heavy platforms where users need to make confident decisions quickly. I like untangling messy workflows, turning dense information into intuitive interactions, and refining details so the experience feels intentional and consistent.<br/><br/> I also care a lot about systems: reusable patterns, documentation, and the small standards that help teams ship faster without losing quality.<br/><br/> 
                <br>
                Please click to see my resume <a href="https://drive.google.com/file/d/1tpSKTbOWIA5X8vQ26N5XA1fRLlI4tAK-/view?usp=sharing" target="_blank">here</a>.<br>
                <br>
                Drop me a line. Let's keep in touch.<br>
                hanbyeolljang@gmail.com 
            </div>
        </div>
        
        <div class="row">
            <div class="title">Skills</div>
            <div class="desc">
                Digital Graphics: Figma, Sketch, XD, Illustration, Photoshop, InDesign, Premiere Pro, After Effect<br>
                Wireframing & Ideation: Hand sketch, Balsamiq<br>
                Prototyping: Figma, Invision, Marvel App, Adobe XD<br>
                Co-working ability: Jira, GitHub, Zeplin, Slack<br>
                Languages & Techniques: English, Korean, HTML5, CSS, JavaScript
            </div>
        </div>
        
        <div class="row">
            <div class="title">Career</div>
            <div class="desc">
                <b>Senior UX designer</b>
                <div class="history">
                    Cirium<br>
                    Feb 2022 – Present<br>
                    <br>
                    <br>
                </div>

                <b>UX designer II</b>
                <div class="history">
                    Cirium<br>
                    Feb 2022 – Mar 2025<br>
                    <br>
                    <br>
                </div>

           <b>Product Designer</b>
                <div class="history">
                    Grove86 Group LLC, Edgewater, NJ<br>
                    Jul 2017 – Feb 2022<br>
                    <br>
                    <br>
                </div>

                <b>Graphic & Web Designer</b>
                <div class="history">
                    Freelance<br>
                    Sep 2013 – Apr 2020<br>
                    <br>
                    <br>
                </div>
                
                <b>Mobile UI/UX Designer</b>
                <div class="history">
                    INU App center, Incheon, S.Korea<br>
                    Apr 2013 - Dec 2013<br>
                    <br>
                    <br>
                </div>

                <b>Mobile UI/UX Designer</b>
                <div class="history">
                    AD Friends, Seoul, S.Korea<br>
                    Jul 2013 - Oct 2013
                </div>
            </div>
        </div>
    </div>

    <div class="copyright">
        <div class="social">
            <a href="https://www.linkedin.com/in/hanbyeoll/" target="_blank"><img src="/portfolio/images/icon-linkdin.png" /></a>
            <a href="https://www.behance.net/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-dribbble.png" /></a>
            <a href="https://dribbble.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-behance.png" /></a>
            <a href="https://github.com/hanbyeoll" target="_blank"><img src="/portfolio/images/icon-github.png" /></a>
        </div>
        <div>
            © Copyright hanbyeoll.github.io. All Rights Reserved.
        </div>
    </div>
</template>

<script>
export default {
	name: 'Page.About',
	mounted() {
        setTimeout(() => {
			const rows = document.querySelectorAll('.row')
            for(var row of rows) {
                row.classList.add('on')
            }
		}, 500)
    }
}
</script>


<style lang="scss">
    @import '@/assets/scss/about.scss';
</style>